<template>
  <v-toolbar class="mb-4"
             flat
             tile>
    <v-toolbar-items>
      <v-btn :to="{name: 'admin.user_contacts.index'}"
             text
             exact>
        Contacts
      </v-btn>
      <v-btn :to="{name: 'admin.user_contacts.upload'}"
             text
             exact>
        Upload
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
export default {}
</script>
